import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography
} from '@material-ui/core'
import { TFunction } from 'i18next'
import DeleteIcon from 'mdi-react/DeleteIcon'
import { FC, useState } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { removeApplicant } from '../../../actions/applications'
import { Applicant } from '../../../types/applications'

interface OwnProps {
  apartmentId?: string
  applicationId: string
  applicants: Applicant[]
  t: TFunction
}

interface DispatchProps {
  doRemoveApplicant: (payload: {
    apartmentId?: string
    applicationId: string
    applicantCode: string
  }) => void
}

type ApplicantsAdminListProps = OwnProps & DispatchProps

const describeApplicant = (applicant: Applicant, t: TFunction) =>
  [applicant.name, applicant.idNumber, applicant.email]
    .filter(Boolean)
    .join(' - ') || t('application.removeApplicant.unnamed')

const ApplicantsAdminList: FC<ApplicantsAdminListProps> = ({
  apartmentId,
  applicationId,
  applicants,
  t,
  doRemoveApplicant
}) => {
  const [pending, setPending] = useState<Applicant | null>(null)

  if (!applicants || applicants.length === 0) {
    return null
  }

  const confirmRemove = () => {
    if (pending) {
      doRemoveApplicant({
        apartmentId,
        applicationId,
        applicantCode: pending.code
      })
    }
    setPending(null)
  }

  return (
    <Grid item xs={12} style={{ marginTop: 16, marginBottom: 8 }}>
      <Typography variant='subtitle2' style={{ marginBottom: 4 }}>
        {t('application.removeApplicant.title')}
      </Typography>
      {applicants.map((applicant: Applicant) => (
        <div
          key={applicant.code}
          style={{ display: 'flex', alignItems: 'center', gap: 8 }}
        >
          <Typography variant='body2' style={{ userSelect: 'text' }}>
            {describeApplicant(applicant, t)}
          </Typography>
          <IconButton
            size='small'
            aria-label={t('application.removeApplicant.button')}
            title={t('application.removeApplicant.button')}
            onClick={() => setPending(applicant)}
          >
            <DeleteIcon size={18} color='#b00020' />
          </IconButton>
        </div>
      ))}

      <Dialog open={Boolean(pending)} onClose={() => setPending(null)}>
        <DialogTitle>{t('application.removeApplicant.confirmTitle')}</DialogTitle>
        <DialogContent>
          <DialogContentText component='div'>
            {t('application.removeApplicant.confirmMessage')}
            <Typography variant='subtitle1' style={{ marginTop: 12 }}>
              {pending ? describeApplicant(pending, t) : ''}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPending(null)}>
            {t('general.cancel')}
          </Button>
          <Button onClick={confirmRemove} style={{ color: '#b00020' }}>
            {t('application.removeApplicant.button')}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  doRemoveApplicant: (payload: {
    apartmentId?: string
    applicationId: string
    applicantCode: string
  }) => dispatch(removeApplicant(payload))
})

export default connect<{}, DispatchProps, OwnProps>(
  null,
  mapDispatchToProps
)(ApplicantsAdminList)
